import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { MonedasConstant } from 'constants/index'

const MonedaFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='MONEDA' htmlFor='select-modalavanz-moneda' md={12} />
      <Col md={12}>
        <Field name='moneda'>
          {({ field }) => (
            <Form.Select {...field} id='select-modalavanz-moneda' isInvalid={iTouched && iError} disabled={fIsSubmitting}>
              {MonedasConstant.__array.map((x, k) => (
                <option key={k} value={x.id}>
                  {x.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(MonedaFormGroup)
